// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"ok_a bhe_px bhe_a bhe_w","FaqAskQuestion__outdated":"ok_b bhe_ul bhe_vz"};